module.exports = __webpack_public_path__ + "AkshatPuri-a3524dcc.webp";